module.exports = __webpack_public_path__ + "static/media/third.d1689b41.svg";